import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_garden_tools: FaireCategoryEntity = {
  token: "cat_garden-tools",
  type: "category",
  name: "Garden tools",
  level: 3,
  parentToken: "cat_home-decor-garden",
  href: "/category/home-decor/garden-outdoor/garden-tools",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
